<template>
  <div class="col-md-12">
    <hotline-list :origin="$route.params.id">
    </hotline-list>
  </div>
</template>

<style lang="scss">
</style>

<script type="text/babel">
  import Item from './Item'
  import HotlineList from "components/Hotline/List"

  export default{

    components:{
        HotlineList
    },
}
</script>



// WEBPACK FOOTER //
// client/components/Customer/HotlineContent/HotlineTable.vue